export default "__VITE_ASSET__Rq6iZ2z9__"